"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
var config_1 = __importDefault(require("../../config"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var getIconEnumValue_1 = __importDefault(require("../../shared/utilities/getIconEnumValue"));
function FaIcon(props) {
    // get size
    var getSize = function () { return (0, getIconEnumValue_1.default)(props.size); };
    var iconLibrary = config_1.default.iconLibrary[props.library || config_1.default.defaults.iconLibrary];
    // add a single pack to library
    fontawesome_svg_core_1.library.add(iconLibrary.pack);
    if (!props.icon) {
        return null;
    }
    return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: [iconLibrary.style, props.icon], className: (0, classMap_1.default)("mpng-ux-faicon mpng-ux-icon", props.className), size: (props.size !== size_enum_1.default.MEDIUM ? props.size : undefined), title: props.title, style: {
            width: props.squared ? Number(getSize()) : undefined,
            height: props.squared ? Number(getSize()) : undefined
        } }));
}
exports.default = FaIcon;
